import React, { useCallback, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classnames from 'classnames'
import routes from '../../../config/routes'
import * as menu from '../../../constants/menu'
import * as reducks from '../../../reducks'
import ButtonShowRed from '../Icons/ButtonShowRed'
import ConsultorMaisLogoImg from '../Icons/ConsultorMaisLogoImg'
import ConsultorMaisLogoName from '../Icons/ConsultorMaisLogoName'
import SantanderLogoWhite from '../Icons/SantanderLogoWhite'
import SantanderLogoWhiteWhitoutText from '../Icons/SantanderLogoWhiteWhitoutText'
import SantanderFooterSidebar from '../Icons/SantanderFooterSidebar'
import Text from '../Text/Text'
import Link from '../Link/Link'
import SideMenu from './SideMenu'
import styles from './sidebar.module.scss'

const Sidebar = () => {
  const dispatch = useDispatch()
  const store = useSelector((state) => state.menuReducer)

  const [expand, setExpand] = useState(false)
  const collapseSideMenu = classnames(styles.sidebar, {
    [styles.expand]: expand
  })
  const [showButton, setShowButton] = useState(false)
  const rotateButtonShowSideBar = classnames(styles.buttonShowSideBar, {
    [styles.showButton]: showButton
  })

  const handleButtonExpand = () => {
    setExpand(!expand)
    setShowButton(!showButton)
  }

  const {
    menu: { list }
  } = store

  const logout = useCallback(() => {
    dispatch(reducks.resources.session.actions.logout())
  }, [dispatch])

  const merged = useMemo(
    () =>
      list
        .map((current) => {
          let newMenu = current

          menu.MENU_LIST.map((item) => {
            if (item.optionId === current.optionId) {
              newMenu = { ...current, ...item }
            }

            if (current.optionId === menu.DASHBOARD_OPTION_ID) {
              const children = newMenu.children.map((son) => {
                return {
                  ...son,
                  route: routes.dashboard.path.replace(':roleId', son.optionId)
                }
              })

              newMenu.children = children
            }
          })

          return newMenu
        })
        .filter((current) => current.optionId !== menu.PROFILE_ITEM_ID),
    [list]
  )

  return (
    <aside className={collapseSideMenu}>
      <div className={styles.bgRadius} />
      <div id="show_sidebar" className={rotateButtonShowSideBar}>
        <button
          id="btn_show_sidebar"
          type="button"
          onClick={handleButtonExpand}
        >
          <ButtonShowRed />
        </button>
      </div>
      <div id="CM_logo" className={styles.logo}>
        <ConsultorMaisLogoImg />
        <ConsultorMaisLogoName />
      </div>
      <SideMenu menus={merged} handleButtonExpand={handleButtonExpand} />
      <div className={styles.subfooter}>
        <button id="CM_btn_sair" type="button" onClick={logout}>
          <Text size="xs" color="gray" variation="lightest" value="Sair" />
        </button>
        <a
          id="CM_link_help"
          href="https://ajuda.portalmais.webmotors.com.br"
          target="blank"
        >
          <Text size="xs" color="gray" variation="lightest" value="Ajuda" />
        </a>
      </div>
      <div className={styles.footer}>
        <div className={styles.itemFooterLogoSantander}>
          <SantanderLogoWhite />
          <SantanderLogoWhiteWhitoutText />
        </div>
        <Link to={routes.termsInternal.path}>
          <Text
            className={styles.footerLabel}
            size="xxxs"
            color="gray"
            variation="light"
            value="Termos e condições de uso"
          />
        </Link>
        <Text size="xxxs" color="gray" variation="light" value="versão 1.4.2" />
        <div className={styles.santanderFooter}>
          <SantanderFooterSidebar />
        </div>
      </div>
    </aside>
  )
}

export default Sidebar
